/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Bidding_N_Battles__Question_0Inputs */

const en_help_center__bidding_n_battles__question_0 = /** @type {(inputs: Help_Center__Bidding_N_Battles__Question_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does the bidding system work?`)
};

/**
* | output |
* | --- |
* | "How does the bidding system work?" |
*
* @param {Help_Center__Bidding_N_Battles__Question_0Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__bidding_n_battles__question_0 = /** @type {((inputs?: Help_Center__Bidding_N_Battles__Question_0Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Bidding_N_Battles__Question_0Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__bidding_n_battles__question_0(inputs)
});